const QUERY_KEYS = {
    EXAMPLE_TEXT_LIST: "exampleTextList",
    CHAT_HISTORY: "chatHistory"
};

export default QUERY_KEYS;
